import React from 'react';

export type Crumb = { label: string; href?: string };

type BreadcrumbsContextValue = {
  crumbs: Crumb[];
  setBreadcrumbs: (items: Crumb[]) => void;
};

const BreadcrumbsContext = React.createContext<BreadcrumbsContextValue | undefined>(undefined);

export const BreadcrumbsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [crumbs, setCrumbs] = React.useState<Crumb[]>([]);

  const setBreadcrumbs = React.useCallback((items: Crumb[]) => {
    setCrumbs(Array.isArray(items) ? items : []);
  }, []);

  const value = React.useMemo(() => ({ crumbs, setBreadcrumbs }), [crumbs, setBreadcrumbs]);

  return (
    <BreadcrumbsContext.Provider value={value}>
      {children}
    </BreadcrumbsContext.Provider>
  );
};

export function useBreadcrumbs(): BreadcrumbsContextValue {
  const ctx = React.useContext(BreadcrumbsContext);
  if (!ctx) throw new Error('useBreadcrumbs must be used within BreadcrumbsProvider');
  return ctx;
}


